import { useData, useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { BsXLg } from "react-icons/bs";

import ImpactList from "./ImpactList.js";
import CharCard from "./CharCard.js";

export default function MapModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    // FUNCTIONS
    
    function goToPlaceAndChar (placeId, charId)
    {
	if (!gData.state.showModals.dialogue || gData.state.currentDialogue === null || gData.state.currentDialogue.charId !== charId) gDispatch({ type: "goToPlaceAndChar", placeId, charId });
	closeMap();
    }
    
    function closeMap () { gDispatch({ type: "closeModal", modal: "map" }); }

    
    // PLACES
    let charCards = (<></>);

    if (gData.state.currentThemeId === null) return (<></>);
    
    if (gData.content.params.oneCharPerPlace)
    {
	charCards = Object
	    .values(gData.content.chars)
	    .filter((charContent) => charContent.placeId !== null)
	    .map((charContent) => {
		const anyChoiceQuestNb = Object.values(gData.state.choiceQuests).filter((quest) => quest.charId === charContent.id && quest.themeId === gData.state.currentThemeId).length;
		const opened = ! gData.content.params.choiceQuests || anyChoiceQuestNb > 0 || charContent.id === "directeur";

		return (
		    <div key={charContent.id} style={{ width: "18%" }} onClick={() => { if (opened) goToPlaceAndChar(charContent.placeId, charContent.id) }}>
			<CharCard charId={charContent.id} pictureWidth={"100%"}/>
		    </div>
		);
	    });
    }

    return (
	<Modal
	    dialogClassName="modal-xl"
	    show={gData.state.showModals.map}
	    onHide={closeMap}
	    centered
	    backdrop={gData.state.showModals.dialogue ? true : "static"}
            keyboard={! gData.state.showModals.dialogue}
	>
	    <Modal.Header className="user-select-none d-flex align-items-center justify-content-between bg-light">
		<Button variant="secondary" className="invisible"><BsXLg/></Button>
		<Modal.Title className="text-uppercase fw-bold">{gData.content.params.mapTitle}</Modal.Title>
		<Button variant="secondary" className={gData.state.showModals.dialogue ? "" : "invisible"} onClick={closeMap}><BsXLg/></Button>
	    </Modal.Header>
	    <Modal.Body className="user-select-none">
		<Row>
		    <Col md={4}>
			<div className="text-uppercase fs-5 text-center mb-2">État de l'entreprise</div>
			<ImpactList type="state"/>
		    </Col>
		    <Col md={8}>
			<div className="d-flex flex-wrap gap-2 justify-content-center align-items-stretch">
			    {charCards}
			</div>
		    </Col>
		</Row>

	    </Modal.Body>
	</Modal>
    );
}
